export default __webpack_public_path__ + "static/media/mz-01.f6d58efa.svg";